import * as React from "react";
import { ActiveCell, SignatureCell } from "../GridComponents";
import EditTime from "./EditTime";
import List from "components/Setting/List";
import { updateTimeType, useTimeType } from "services/timeTypeService";

const TimeList = () => {
  const { data: gridData, loading } = useTimeType();

  return (
    <List
      editAction={updateTimeType}
      editFormComponent={EditTime}
      component="timeTypes"
      columns={[
        { field: "name", title: " ", cell: SignatureCell, width: "80" },
        { field: "code", title: "Code" },
        { field: "name", title: "Time Type" },
        { cell: ActiveCell, title: "Active", field: "active", width: "80" },
      ]}
      gridData={gridData}
      loading={loading}
    />
  );
};

export default TimeList;
